// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"167":"spareparts","571":"settings","831":"loginscreen"}[chunkId] || chunkId) + "." + {"167":"a703861f","571":"82238a5d","831":"8afce4c5","970":"daf3737d"}[chunkId] + ".js";
};